import { useTheme } from '@mui/material/styles';
import { ListItemButton, ListItemIcon, ListItemText, Typography, Tooltip } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { MenuItemType } from '../../../../../menu-items';
import HelpIcon from '@mui/icons-material/Help';
interface NavItemProps {
  item: MenuItemType;
  open?: boolean;
  nestLevel?: number;
}

const NavItem: React.FC<NavItemProps> = ({ item, open, nestLevel }: NavItemProps) => {
  const theme = useTheme();
  const location = useLocation();
  const pathArray = location.pathname.split('/');
  let mainpath = '';
  if (pathArray.length > 1) {
    mainpath = '/' + pathArray[1];
  }
  return (
    <ListItemButton
      sx={{
        borderStartStartRadius: `${20}px`,
        borderEndStartRadius: `${20}px`,
        mb: 0,
        alignItems: 'flex-start',
        backgroundColor: 'inherit',
        color: 'black',
        py: 1,
        // pl: `${20}px`,
        pl: open ? 3 * (nestLevel ? nestLevel : 0) + 2.5 : null,
        borderRadius: 0,
        '&.Mui-selected': {
          bgcolor: '#21aeee1f',
          color: 'black !important'
        },
        ':hover': {
          bgcolor: '#21aeee0e'
        },
        '&.Mui-selected::after': {
          width: '5px',
          background: theme.palette.primary.main,
          height: '100%',
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          right: 0
        }
      }}
      selected={mainpath == item.url}
      component={Link} // <-- pass Link as component
      to={item.url ? item.url : '#'}
    >
      <ListItemIcon
        sx={{
          minWidth: '30px',
          mr: open ? 1 : 'auto',
          justifyContent: 'center',
          alignSelf: 'center'
        }}
      >
        <Tooltip title={!open ? (item.title ? item.title : '') : ''}>
          {item.iconElement ? item.iconElement : <HelpIcon />}
        </Tooltip>

      </ListItemIcon>
      <ListItemText
        primary={<Typography variant="itemManu">{item.title}</Typography>}
        sx={{ opacity: open ? 1 : 0 }}
      />
    </ListItemButton>
  );
};

export default NavItem;
